import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminGenericProducts from "@/pages/admin/AdminGenericProducts";

export const Route = createFileRoute("/admin/products/$hub/")({
  component: () => (
    <ProtectedRoute>
      <AdminGenericProducts />
    </ProtectedRoute>
  ),
});
